<div class="mx-auto d-table">
    
    <div class="row leyenda">
      <div class="colorLeyenda d-table-cell">
        <div class="dot dotRealizada"></div>
      </div>
      <div class="col d-table-cell">
          {{ 'DISPOSITIVOS.HOMEDELIVERY.MENSAJE_LEYENDA' | translate }}
      </div>
    </div>
    <div class="row leyenda">
      <div class="colorLeyenda d-table-cell">
        <div class="dot dotTodoDia"></div>
      </div>
      <div class="col d-table-cell mas-informacion" (click)="abrirURLinfo()">
        {{ 'DISPOSITIVOS.HOMEDELIVERY.MAS_INFO' | translate }}
      </div>
    </div>
  

  </div>
  